"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnrichAIContainer = void 0;
const react_1 = __importStar(require("react"));
const react_router_1 = require("react-router");
const context_1 = require("./context");
const enrich_ai_routes_1 = require("./enrich-ai.routes");
const hooks_1 = require("./hooks");
const apollo_client_utils_1 = require("../apollo-client/apollo-client.utils");
const hooks_2 = require("../hooks");
const router_1 = require("../router");
const EnrichAIContainer = () => {
    const { featureFlagsService } = (0, hooks_2.useFeatureFlagsService)();
    const routes = (0, enrich_ai_routes_1.getEnrichAIRoutes)(featureFlagsService);
    (0, react_1.useEffect)(() => {
        const handler = (event) => {
            if ((0, apollo_client_utils_1.isAbortError)(event.reason)) {
                event.preventDefault();
            }
        };
        window.addEventListener('unhandledrejection', handler);
        return () => window.removeEventListener('unhandledrejection', handler);
    }, []);
    (0, hooks_2.useTracking)();
    // Initialize selected project and catalog
    const { isReady: areCatalogSettingsReady } = (0, hooks_1.useCatalogSettings)();
    return (react_1.default.createElement(context_1.CatalogActivityProgressProvider, null, areCatalogSettingsReady && (react_1.default.createElement(react_router_1.Routes, null, routes.map((route, i) => react_1.default.createElement(react_router_1.Route, Object.assign({ key: i }, route))), react_1.default.createElement(react_router_1.Route, { path: "*", element: react_1.default.createElement(react_router_1.Navigate, { to: router_1.EnrichSection.Workspace }) })))));
};
exports.EnrichAIContainer = EnrichAIContainer;
exports.default = exports.EnrichAIContainer;
